import React from 'react';
import { addressFields, includeAddressFields } from '../addressFields';
import { MdAdd } from 'react-icons/md';
import PortalButton from './PortalButton';
import FormFieldEditor from './FormFieldEditor';

export default function FormBuilder({ fields, setFields, onDocument }) {
  return (
    <>
      {fields.map((field, index) => (
        <FormFieldEditor
          key={index}
          field={field}
          index={index}
          fields={fields}
          onChange={(value) => setFields((all) => all.map((f, i) => (i === index ? value : f)))}
          onDocument={onDocument ? () => onDocument(index, field) : undefined}
          onAddress={() => setFields((all) => includeAddressFields(all, index))}
          onMove={(delta) =>
            setFields((all) => {
              const result = [...all];
              [result[index], result[index + delta]] = [result[index + delta], result[index]];
              return result;
            })
          }
          onRemove={() => setFields((all) => all.filter((_, i) => i !== index))}
        />
      ))}
      <div className="portal-admin-actions actions-group">
        <PortalButton
          className="btn btn-success"
          type="button"
          disabled={addressFields.every(field => fields.some(current => current.id === field.id))}
          onClick={() => setFields(all => includeAddressFields(all))}
        >
          <MdAdd /> Adicionar endereço completo
        </PortalButton>
        <PortalButton
          className="btn btn-success"
          type="button"
          onClick={() =>
            setFields((all) => [
              ...all,
              {
                id: 'campo_' + Date.now(),
                label: 'Novo campo',
                type: 'text',
                required: true,
                max_length: 255,
              },
            ])
          }
        >
          <MdAdd /> Adicionar campo
        </PortalButton>
      </div>
    </>
  );
}
